<template>
  <div class="graphical-verification-code" @click="getGraphicalCode">
    <img :src="src">
  </div>
</template>

<script>
export default {
  name: "GraphicalVerificationCode",
  props: {
    source: {
      type: String,
      default: 'loginReg'
    }
  },
  data() {
    return {
      src: ""
    }
  },
  computed: {
    smsCodeTimeOut() {
      return this.$store.getters["globe/smsCodeTimeOut"]
    }
  },
  watch: {
    smsCodeTimeOut(v) {
      if (v) {
        this.$store.commit("globe/updataSmsCodeTimeOut", false)
        this.getGraphicalCode()
      }
    }
  },
  created() {
    this.getGraphicalCode()
  },
  methods: {
    getGraphicalCode() {
      this.$store.dispatch('globe/getGraphicalCode', { source: this.source }).then(({ msg }) => {
        this.src = msg
      }).catch(({ msg })   => {
        this.$Message.error(msg)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.graphical-verification-code{
  width: 80px;
  height: 40px;
  margin-left: 40px;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>